import { type Html, html, rune, View } from 'rune-ts';
import klass from './IndexSection.module.scss';
import { font, staticFont } from '@services/MarppleShop/shared/typography';
import { getResizedUrl } from '@services/MarppleShop/shared/util/image.ts';

export class IndexSection extends View {
  constructor() {
    super({});
  }

  override template(): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const img_urls = {
      content1:
        '//s3.marpple.co/files/u_4648126/2025/6/original/63481882cd40900f6d4f46597d068260af8fd47e1.png',
      content2:
        '//s3.marpple.co/files/u_4648126/2025/6/original/04de0db8fd61918ff151f3d0b0c8149f557e1ead6.png',
      content3:
        '//s3.marpple.co/files/u_4648126/2025/6/original/2f936bffc011c1ee08e00ef4df8f68d38337e4a11.png',
      content3_text: is_mobile
        ? '//s3.marpple.co/files/u_4648126/2025/6/original/2da215d8871ea23aaf88af8eae17093aeeb9877a2.png'
        : '//s3.marpple.co/files/u_4648126/2025/6/original/f53b437d813e548b606428353296b4f476b227001.png',
      content4:
        '//s3.marpple.co/files/u_4648126/2025/6/original/317d9bd7dabc33782282dc53fe7846e698940dac3.png',
      content5:
        '//s3.marpple.co/files/u_4648126/2025/6/original/3194f5fe2e4bba963734184ed31b47297f057e112.png',
    };
    const texts = {
      title: html.preventEscape(`버추얼 크리에이터라면<br />마럽이에게 굿즈 제작 맡겨봐요`),
      content1: {
        title: '물의 신관 유우나의 마플샵 정착기',
        desc: html.preventEscape(`아쿠아쿠— 물결 인사! <br />나는 MPS-120 행성에서 온 유우나야!<br />
               <br />내 고향으로 돌아가려면<br />10만 리터의 기쁨의 눈물이 필요한데<br />
               혼자선 너무 먼 길이라 고민하던 그때!`),
      },
      content2: {
        title: '마럽이 등장',
        desc: html.preventEscape(`그때 구세주같은 마플샵의 마럽이가 등장했어!<br />
                    마럽이의 제안에 용기 충전하고<br />
                    굿즈 디자인부터 판매 페이지 오픈까지<br />
                    지구별에 정착하기 위한 풀세팅 완료!`),
      },
      content3: {
        title: '마플샵과 함께 굿즈 해결',
        desc: html.preventEscape(`혹시 나처럼 막막했던 친구들이 있을까?<br />
                  그렇다면 마럽이가 날 도와줬던 것처럼<br />
                  나, 유우나가 너희를 도와줄게!`),
      },
      content4: {
        title: '굿즈 파트너스, 지금 신청해봐',
        desc: html.preventEscape(`마플샵의 마럽이와 함께라면 <br />
                    키링부터 인형까지 원하는 건 다 만들 수 있어! <br />
                    지금 시작해볼까?`),
      },
    };

    return is_mobile
      ? html`
          <section class="${klass.container}">
            <div class="${font('20_bold')}">${texts.title}</div>

            <div class="${klass.content}">
              <img
                src="${getResizedUrl({
                  url: img_urls.content1,
                  width: 375 * 2,
                  quality: 85,
                  format: 'webp',
                })}"
                class="${klass.image} ${klass.image_md}"
                alt="굿즈 파트너 이미지"
              />
              <div class="${klass.desc_wrapper}">
                <div class="${font('16_bold')}">${texts.content1.title}</div>
                <div class="${font('12_medium')}">${texts.content1.desc}</div>
              </div>
            </div>

            <div class="${klass.content_wrapper}">
              <div class="${klass.content}">
                <img
                  src="${getResizedUrl({
                    url: img_urls.content2,
                    width: 208 * 2,
                    quality: 85,
                    format: 'webp',
                  })}"
                  class="${klass.image} ${klass.image_md}"
                  alt="굿즈 파트너 이미지"
                />
                <div class="${klass.desc_wrapper} ${klass.reverse}">
                  <div class="${font('16_bold')}">${texts.content2.title}</div>
                  <div class="${font('12_medium')}">${texts.content2.desc}</div>
                </div>
              </div>
            </div>

            <div class="${klass.content}">
              <div class="${klass.image_wrapper}">
                <img
                  src="${getResizedUrl({
                    url: img_urls.content3,
                    width: 220 * 2,
                    quality: 85,
                    format: 'webp',
                  })}"
                  class="${klass.maluv}"
                  alt="굿즈 파트너 이미지"
                />
                <img
                  src="${getResizedUrl({
                    url: img_urls.content3_text,
                    width: 220 * 2,
                    quality: 85,
                    format: 'webp',
                  })}"
                  class="${klass.text}"
                  alt="굿즈 파트너 이미지"
                />
              </div>
              <div class="${klass.desc_wrapper}">
                <div class="${font('16_bold')}">${texts.content3.title}</div>
                <div class="${font('12_medium')}">${texts.content3.desc}</div>
              </div>
            </div>

            <div class="${klass.content}">
              <img
                src="${getResizedUrl({
                  url: img_urls.content4,
                  width: 182 * 2,
                  quality: 85,
                  format: 'webp',
                })}"
                class="${klass.image} ${klass.image_sm} ${klass.product_img}"
                alt="굿즈 파트너 이미지"
              />
            </div>

            <div class="${klass.content_wrapper}">
              <div class="${klass.content}">
                <img
                  src="${getResizedUrl({
                    url: img_urls.content5,
                    width: 240 * 2,
                    quality: 85,
                    format: 'webp',
                  })}"
                  class="${klass.image} ${klass.image_lg}"
                  alt="굿즈 파트너 이미지"
                />
                <div class="${klass.desc_wrapper}">
                  <div class="${font('16_bold')}">${texts.content4.title}</div>
                  <div class="${font('12_medium')}">${texts.content4.desc}</div>
                </div>
              </div>
            </div>
          </section>
        `
      : html`
          <section class="${klass.container}">
            <div class="${klass.navigation}">
              <div class="${staticFont('bebas_20_bold')}">CHAPTER</div>
              <div class="${klass.nav_items} ${font('20_regular')}">
                <div class="${klass.nav_item}">1. 굿즈 제작</div>
                <div class="${klass.nav_item}">2. 유튜브 쇼핑</div>
                <div class="${klass.nav_item}">3. 홍보 마케팅</div>
                <div class="${klass.nav_item} ${klass.last}">4. FAQ</div>
              </div>
            </div>

            <div class="${klass.content_container}">
              <div class="${font('40_bold')}">${texts.title}</div>
              <div class="${klass.content_wrapper}">
                <div class="${klass.content_section_1}">
                  <div class="${klass.content}">
                    <img
                      src="${getResizedUrl({
                        url: img_urls.content1,
                        width: 645 * 2,
                        quality: 85,
                        format: 'webp',
                      })}"
                      class="${klass.image_md}"
                      alt="굿즈 파트너 이미지"
                    />
                    <div class="${klass.desc_wrapper}">
                      <div class="${font('24_bold')}">${texts.content1.title}</div>
                      <div class="${font('16_medium')}">${texts.content1.desc}</div>
                    </div>
                  </div>
                  <div class="${klass.content_side}">
                    <div class="${klass.desc_wrapper}">
                      <div class="${font('24_bold')}">${texts.content2.title}</div>
                      <div class="${font('16_medium')}">${texts.content2.desc}</div>
                    </div>
                    <img
                      src="${getResizedUrl({
                        url: img_urls.content2,
                        width: 702 * 2,
                        quality: 85,
                        format: 'webp',
                      })}"
                      alt="굿즈 파트너 이미지"
                    />
                  </div>
                </div>
                <div class="${klass.content}">
                  <div class="${klass.image_wrapper}">
                    <img
                      src="${getResizedUrl({
                        url: img_urls.content3,
                        width: 432 * 2,
                        quality: 85,
                        format: 'webp',
                      })}"
                      class="${klass.maluv}"
                      alt="굿즈 파트너 이미지"
                    />
                    <img
                      src="${getResizedUrl({
                        url: img_urls.content3_text,
                        width: 512 * 2,
                        quality: 85,
                        format: 'webp',
                      })}"
                      class="${klass.text}"
                      alt="굿즈 파트너 이미지"
                    />
                  </div>
                  <div class="${klass.desc_wrapper}">
                    <div class="${font('24_bold')}">${texts.content3.title}</div>
                    <div class="${font('16_medium')}">${texts.content3.desc}</div>
                  </div>
                </div>

                <div class="${klass.content_section_3}">
                  <div class="${klass.content}">
                    <img
                      src="${getResizedUrl({
                        url: img_urls.content4,
                        width: 664 * 2,
                        quality: 85,
                        format: 'webp',
                      })}"
                      class="${klass.image_lg}"
                      alt="굿즈 파트너 이미지"
                    />
                    <div class="${klass.desc_wrapper}">
                      <div class="${font('24_bold')}">${texts.content4.title}</div>
                      <div class="${font('16_medium')}">${texts.content4.desc}</div>
                    </div>
                  </div>
                  <img
                    src="${getResizedUrl({
                      url: img_urls.content5,
                      width: 664 * 2,
                      quality: 85,
                      format: 'webp',
                    })}"
                    class="${klass.side_image}"
                    alt="굿즈 파트너 이미지"
                  />
                </div>
              </div>
            </div>
          </section>
        `;
  }
}
